import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuestionSelect, QuestionSelectOption } from 'src/app/models/question-select';
import { QuestionText } from 'src/app/models/question-text';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']
})
export class QuestionComponent implements OnInit {

  @Input() question:any; // QuestionSelect | QuestionText | QuestionRating
  @Input() isEdit:boolean = false;
  @Input() hasBack:boolean = false;
  @Output() questionInputed = new EventEmitter();
  @Output() questionSkipped = new EventEmitter();
  @Output() backToTop = new EventEmitter();
  @Output() backToPrev = new EventEmitter();

  multiSelectOptionWrapperList: Array<{
    isSelected: boolean,
    option: QuestionSelectOption
  }> = [];

  constructor(
  ) { }

  ngOnInit() {
    if(this.question.isMultiSelect){
      for(let option of this.question.options){
        this.multiSelectOptionWrapperList.push({
          isSelected: false,
          option: option
        });
      }
    }
  }

  selected(option:QuestionSelectOption){
    // console.log(this.question.value, option.key);
    if(this.question.isMultiSelect){
      for(let object of this.multiSelectOptionWrapperList){
        if(object.option.key === option.key){
          object.isSelected = !object.isSelected;
          break;
        }
      }
      this.question.value = this.getMultiSelectQuestionValue();
    }
    else{
      this.question.value = option.key;
      // すぐに遷移すると押したかがわからないので300msずらす
      // setTimeout(() => {
        this.done(); // 単一選択肢は項目選択で次へ
      // }, 100);
    }
  }

  getMultiSelectQuestionValue(){
    let value = "";
    for(let object of this.multiSelectOptionWrapperList){
      if(object.isSelected){
        value += "," + object.option.key;
      }
    }
    return value.replace(",", "");
  }

  rated(rate:number){
    this.question.value = rate;
    // すぐに遷移すると押したかがわからないので300msずらす
    setTimeout(() => {
      this.done(); // 評価は項目選択で次へ
    }, 300);
  }

  back(){
    this.backToPrev.emit();
  }

  done(){
    if(this.question.required && this.question.value == null){
      return;
    }
    // console.log(this.question);
    this.questionInputed.emit(this.question);
  }
  skip(){
    // nullに設定する
    this.questionSkipped.emit(this.question);
  }

  backToTopClicked(){
    this.backToTop.emit();
  }

  getConditionText(){
    if(this.question.required && this.question.isMultiSelect){
      return "※必須項目, 複数選択可";
    }
    else if(this.question.required){
      return "※必須項目";
    }
    else if(this.question.isMultiSelect){
      return "※複数選択可";
    }
  }

  decideRowNum(question:QuestionSelect){
    const thresholdLength = 10;
    const longTextOptions = question.options.filter(option => this.get2byteLength(option.value) > thresholdLength);
    if(longTextOptions && longTextOptions.length > 0){
      return "row1";
    }

    if(question.options.length >= 5){
      return "row3";
    }
    else{
      return "row2";
    }
  }

  get2byteLength(str: string): number{
    let count: number = 0;
    for (let i = 0, len = str.length; i < len; i++) {
      let c = str.charCodeAt(i);

      if (!str[i].match(/\r?\n/g)){ // 改行コード判定
        if (c >= 0x0 && c <= 0x7f){ // 全角半角判定
          count += 0.5;
        } else {
          count += 1;
        }
      }
    }
    return count;
  }
}
